<script>
    let visible = false;
    export let closable = true;
    export const close = () => visible = false;
    export const open = () => visible = true;
</script>

{#if visible}
<div on:click={close} class="modalBack">
    <div on:click|stopPropagation class="modalWindow">
        <slot/>
    </div>
</div>
{/if}

<style type="text/css">
    .modalBack {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        background-color: rgba(0, 0, 0, 0.5);
    }

    .modalWindow {
        background-color: white;
        border-radius: 10px;
        box-shadow: 5px 5px 5px gray;
        padding: 30px;
        margin-top: 50px;
        max-width: 80%;
    }
</style>
